import React from "react";

export const chartTooltipStyle = {
    background: "#1a1030",
    border: "none",
    borderRadius: 8,
    padding: "8px 12px",
    boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
};
export const chartTooltipLabelStyle = { color: "#ffffff", fontWeight: 600, marginBottom: 2 };
export const chartTooltipItemStyle = { color: "#e6e1f7", fontSize: 12 };

export const TypeTooltip = ({ active, payload }) => {
    if (!active || !payload || !payload.length) return null;
    const row = payload[0].payload;
    return (
        <div style={chartTooltipStyle}>
            <div style={chartTooltipLabelStyle}>{row.label}</div>
            <div style={chartTooltipItemStyle}>{row.count} requests</div>
        </div>
    );
};

export const TimeTooltip = ({ active, payload }) => {
    if (!active || !payload || !payload.length) return null;
    const row = payload[0].payload;
    return (
        <div style={chartTooltipStyle}>
            <div style={chartTooltipLabelStyle}>{row.label}</div>
            <div style={chartTooltipItemStyle}>Avg: {row.hours}h to complete</div>
        </div>
    );
};

export const CompletedTooltip = ({ active, payload }) => {
    if (!active || !payload || !payload.length) return null;
    const row = payload[0].payload;
    return (
        <div style={chartTooltipStyle}>
            <div style={chartTooltipItemStyle}>{Math.round(row.completed)} completed</div>
        </div>
    );
};